import { render, staticRenderFns } from "./TabFrame.vue?vue&type=template&id=1429805f&scoped=true&"
import script from "./TabFrame.vue?vue&type=script&lang=js&"
export * from "./TabFrame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1429805f",
  null
  
)

export default component.exports